import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import {
  dataConnectionsHachwimsAutocompleteSx,
  dataConnectionsFieldSx,
} from "./GroupAccessDrawer.style";

export const FACILITIES_LOADING_ID = "__facilities_loading__";
export const FACILITIES_LOADING_OPTION_CLASS = "facilities-loading-option";

export const FACILITIES_LOADER_SIZE = 20;

export const DataConnectionsMqttControlsRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 8,
  flex: 1,
  minWidth: 0,
});

export const DataConnectionsHachwimsControlsRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: 8,
  flex: 1,
  minWidth: 0,
});

export const DataConnectionsMqttSwitch = styled(Switch)({
  flexShrink: 0,
  marginLeft: -4,
});

export const DataConnectionsHachwimsSwitch = styled(Switch)({
  flexShrink: 0,
  marginLeft: -4,
  marginTop: 6,
});

export const StyledFacilitiesLoader = styled(CircularProgress)({
  color: "var(--theme-color)",
});

export const StyledFacilitiesInputLoader = styled(StyledFacilitiesLoader)({
  marginRight: 8,
});

export const FacilitiesLoadingOption = styled("li")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  boxSizing: "border-box",
  padding: "16px 0",
  margin: 0,
  pointerEvents: "none",
  [`&.${FACILITIES_LOADING_OPTION_CLASS}`]: {
    justifyContent: "center",
    paddingLeft: 0,
    paddingRight: 0,
  },
});

export const FACILITY_OPTION_FONT_SIZE = "12.5px";

export const FacilityOptionRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  paddingTop: 4,
  paddingBottom: 4,
  paddingRight: 8,
  fontSize: FACILITY_OPTION_FONT_SIZE,
  "& .MuiListItemText-primary": {
    fontSize: FACILITY_OPTION_FONT_SIZE,
  },
});

export const FacilityOptionIconBox = styled(Box)({
  marginRight: 8,
  padding: "9px",
  boxSizing: "content-box",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
});

export const StyledHachwimsAutocomplete = styled(Autocomplete)(() => ({
  ...dataConnectionsHachwimsAutocompleteSx,
  flex: 1,
  minWidth: 0,
  [`& .${FACILITIES_LOADING_OPTION_CLASS}`]: {
    justifyContent: "center !important",
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
  },
}));

export const dataConnectionsMqttFieldSx = {
  ...dataConnectionsFieldSx,
  flex: 1,
  minWidth: 0,
};

export const hachwimsFacilitiesListboxStyle = {
  maxHeight: "min(40vh, 260px)",
  overflow: "auto",
  fontSize: FACILITY_OPTION_FONT_SIZE,
};

export const getHachwimsAutocompleteSlotProps = (modalZIndex) => ({
  popper: {
    placement: "bottom-start",
    strategy: "fixed",
    sx: { zIndex: modalZIndex },
  },
  paper: {
    sx: { mt: 0.5 },
  },
});
